/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import cybersecurityBg1 from '../../../../../../assets/education/cybersecurity/section0-bg2.png';
import cybersecurityBg2 from '../../../../../../assets/education/cybersecurity/section0-bg1.png';
import { useStore } from '../../../../store';
import VideoTranscript from '../../components/VideoTranscript/index';
import { WTitle } from '../../components/Widget';
import useIntersectionObserver from '../../../../../../hooks/useIntersectionObserver';

interface ISection1Props {
  settings: any;
}

const Section0: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const { getParagraphState } = useStore();
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[0],
    [settings?.paragraphs]
  );
  const { targetRef, isVisible } = useIntersectionObserver({
    threshold: 1, // 元素 30% 进入视口时触发
    rootMargin: '-50px', // 根边距缩小 50px（需元素进入视口 50px 后才判定）
  });
  React.useEffect(() => {
    const onPlay = () => {
      if (process.env.REACT_APP_HOST_TYPE === 'dev') {
        return;
      }
      const elem = document?.querySelector('#video900');
      if (elem?.requestFullscreen) {
        try {
          elem.requestFullscreen();
        } catch (error) {
          console.log(error);
        }
        document
          ?.querySelector('#video900')
          ?.removeEventListener('play', onPlay);
      }
    };
    document?.querySelector('#video900')?.removeEventListener('play', onPlay);
    document
      ?.querySelector('#video900')
      ?.addEventListener('play', onPlay, { passive: true });
    return () =>
      document?.querySelector('#video900')?.removeEventListener('play', onPlay);
  }, []);

  return (
    <div className="cybersecurity-landing course-landing">
      <WTitle title={paragraphsSettings.header} />
      <div className="cybersecurity-landing-text">
        <div className="cybersecurity-landing-tip">
          <div className="cybersecurity-landing-tip-title" ref={targetRef}>
            {isVisible && (
              <span className="text-focus-in">
                {paragraphsSettings.description}
              </span>
            )}
          </div>
        </div>
      </div>
      <div className="course-landing-content">
        <div className="course-landing-text">
          <div className="video_box">
            <div className="video-container">
              <video
                id="video900"
                width="100%"
                controls
                autoPlay={process.env.REACT_APP_HOST_TYPE !== 'dev'}
              >
                <source
                  src={paragraphsSettings?.landingVideo?.src}
                  type="video/mp4"
                />
                Your browser does not support HTML video.
              </video>
              <VideoTranscript transcripts={paragraphsSettings.transcripts} />
            </div>
          </div>
        </div>
      </div>
      <img src={cybersecurityBg1} className="cybersecurity-bg1" alt="" />
      <img src={cybersecurityBg2} className="cybersecurity-bg2" alt="" />
      <span className="h5-cybersecurity-bg3"></span>
    </div>
  );
};

export default Section0;
